/* Sportera - Bandeau SOLDES : rend toute la banniere cliquable ET remplace le bouton natif Dawn */
/* par un element 100% custom, en reutilisant le lien/texte deja definis nativement. */
/* Scope strict a #shopify-section-image_banner. N'affecte aucune autre section. */
(function () {
  var section = document.getElementById('shopify-section-image_banner');
  if (!section) return;

  var banner = section.querySelector('.banner');
  if (!banner) return;

  var nativeLink = banner.querySelector('.banner__buttons a[href]');
  if (!nativeLink) return;

  var href = nativeLink.getAttribute('href');
  var label = nativeLink.textContent.trim();
  if (!href || href === '#' || !label) return;

  var content = banner.querySelector('.banner__content');
  if (!content) return;

  var wrap = document.createElement('div');
  wrap.className = 'sp-soldes-cta-wrap';

  var cta = document.createElement('a');
  cta.className = 'sp-soldes-cta';
  cta.href = href;
  cta.textContent = label;

  wrap.appendChild(cta);
  content.appendChild(wrap);

  banner.classList.add('sp-soldes-clickable');

  banner.addEventListener('click', function (e) {
    if (e.target.closest('a, button')) return;
    window.location.href = href;
  });
})();
